module.exports = __webpack_public_path__ + "static/img/client-b.41ef3be8.png";